// Конфигурация API
export const API_CONFIG = {
  // Учетные данные для доступа к API
  credentials: {
    username: import.meta.env.VITE_API_USERNAME || "",
    password: import.meta.env.VITE_API_PASSWORD || "",
  },

  // Базовый URL API
  baseURL: import.meta.env.VITE_API_BASE_URL || "",

  // Таймаут запросов (в миллисекундах)
  timeout: 15000,

  // Автоматическая авторизация при инициализации
  autoAuth: true,

  // Режим отладки
  debug: true,

  // Уровень логирования
  logLevel: "verbose", // 'error' | 'warn' | 'info' | 'verbose'
};
